export default __webpack_public_path__ + "static/media/smallUser.2737911a.svg";